import { getCollectorOnCase, getJournalNumber, } from '@debbie/common/dist/cases/index.js';
import { UdbetalingsRekvisitioner, courts, } from '@debbie/common/dist/court/index.js';
import { getContactPerson } from '@debbie/common/dist/customers/index.js';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { PayoutState, PayoutType, } from '@debbie/common/dist/economy/payouts/index.js';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import { BankAccountType, Currency, Entity, formatNumber, } from '@debbie/common/dist/index.js';
import { Direction, InteractionType, OutgoingState, } from '@debbie/common/dist/interactions/index.js';
import * as interactions from '@debbie/cortex/dist/api/interactions.js';
import * as payoutsAPI from '@debbie/cortex/dist/api/payouts.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { useEmailServer } from '@debbie/cortex/dist/email-servers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import { useUsers } from '@debbie/cortex/dist/users/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from '../Grid/index.js';
import { Button, Modal, MoneyInput, SearchInput, Select } from '../index.js';
const retsafgift = {
    bpk: () => 75000,
    politifremstilling: () => 40000,
    fogedrekvisition: () => 75000,
};
const UdbetalingsrekvisitionModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const usersLoadable = useUsers();
    const allUsers = h.hasData(usersLoadable) ? usersLoadable.data : null;
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const creditorLoadable = useCreditor(props.case.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const customerLoader = useCustomer(props.case.customerId);
    const customer = h.hasData(customerLoader) ? customerLoader.data : null;
    const collectorLoadable = useCollector((props.case &&
        creditor &&
        getCollectorOnCase(props.case.type, props.case.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId)) ||
        undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const emailServerLoadable = useEmailServer(collector?.emailServerId);
    const emailServer = h.hasData(emailServerLoadable)
        ? emailServerLoadable.data
        : null;
    const [responsibleUdbetalingsrekvisition, setResponsibleUdbetalingsrekvisition,] = useState(localStorage.economyResponsibleUserId);
    const [courtFee, setCourtFee] = useState(undefined);
    const [udbetalingsrekvisitionType, setUdbetalingsrekvisitionType] = useState(null);
    const [loadingUdbetalingsrekvisition, setLoadingUdbetalingsrekvisition] = useState(false);
    const getUdbetalingsrekvisitionAmount = () => {
        if (typeof courtFee !== 'undefined') {
            return courtFee;
        }
        switch (udbetalingsrekvisitionType) {
            case UdbetalingsRekvisitioner.Betalingspåkrav:
                return retsafgift.bpk();
            case UdbetalingsRekvisitioner.Politifremstilling:
                return retsafgift.politifremstilling();
            case UdbetalingsRekvisitioner.Fogedrekvisition:
                return retsafgift.fogedrekvisition();
            default:
                return 0;
        }
    };
    const getTotalAmount = () => {
        if (!props.case) {
            return 0;
        }
        const balance = -helpers.overview.balanceCategory(props.caseVouchers, VoucherCategory.PRINCIPAL);
        return balance;
    };
    const debtorContact = customer && getContactPerson(customer, props.case);
    const court = debtorContact && debtorContact.details.courtId
        ? courts.find((c) => c.id === debtorContact.details.courtId)
        : null;
    const getTo = () => {
        const account = (allUsers || []).find((t) => t.id === responsibleUdbetalingsrekvisition);
        if (!account || account.email == null) {
            throw new Error('Could not find account');
        }
        return account.email;
    };
    const journalNumber = getJournalNumber(props.case.customJournalNumber, props.case.id, debtorContact?.id ?? null);
    const sendRequisition = async () => {
        setLoadingUdbetalingsrekvisition(true);
        try {
            if (!emailServer) {
                throw new Error('Could not find email server');
            }
            if (!collector) {
                throw new Error('Could not find collector');
            }
            if (!creditor) {
                throw new Error('Could not find creditor');
            }
            if (!court) {
                throw new Error('Could not find court');
            }
            const amount = getUdbetalingsrekvisitionAmount();
            if (!amount) {
                throw new Error('Amount is required');
            }
            await payoutsAPI.create({
                type: PayoutType.CourtFee,
                state: PayoutState.Created,
                currency: Currency.DKK,
                amount,
                recipientText: journalNumber,
                referenceType: Entity.Case,
                referenceId: props.case.caseId,
                caseId: props.case.caseId,
                caseSequentialId: props.case.id,
                account: {
                    type: BankAccountType.Danish,
                    accountNumber: court.accountnumber,
                    registrationNumber: court.registrationnumber,
                },
                details: {
                    courtId: court.courtId,
                },
            });
            await interactions.create({
                referenceId: props.case.caseId,
                referenceType: Entity.Case,
                direction: Direction.OUTGOING,
                minVisibilityRole: 'client',
                state: OutgoingState.SENT,
                type: InteractionType.Email,
                details: {
                    server: emailServer.id,
                    subject: `Ny udbetalingsrekvisition fra ${collector.name} [j.nr.: ${journalNumber}]`,
                    from: `${emailServer.fromName} <${emailServer.fromEmail}>`,
                    body: '',
                    html: `
                    <p><b>Type udbetalingsrekvisition:</b> ${udbetalingsrekvisitionType}
                    <p><b>Retskreds:</b> ${court.name} (Reg.- og kontonr.: ${court.registrationnumber}${court.accountnumber})</p>
                    <p><b>Sendt af:</b> ${me && `${me.firstName} ${me.lastName}`}</p>
                    <p><b>Klient:</b> ${creditor.name}</p>
                    <p><b>J.nr.:</b> ${journalNumber}</p>
                    <p><b>Beløb:</b> ${formatNumber(getUdbetalingsrekvisitionAmount() || 0)}</p>
                    `,
                    to: getTo(),
                },
            });
        }
        catch (err) {
            console.error(err);
            alert('Error sending');
        }
        setLoadingUdbetalingsrekvisition(false);
        props.setModalOpen(false);
    };
    return (React.createElement(Modal, { onToggle: props.toggleModal, header: lang.tribunal.requisition, maxWidth: "400px" },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("p", null,
                    lang.tribunal.court,
                    ":",
                    ' ',
                    React.createElement("b", null, court ? court.name : lang.tribunal.noCourt)),
                React.createElement(Select, { value: udbetalingsrekvisitionType, onChange: (e) => {
                        setUdbetalingsrekvisitionType(e.target.value);
                    } },
                    React.createElement("option", null,
                        "-- ",
                        lang.tribunal.typeOfRequisituion,
                        " --"),
                    Object.values(UdbetalingsRekvisitioner).map((r) => (React.createElement("option", { key: r, value: r }, lang.tribunal.types[r])))),
                React.createElement(SearchInput, { searchAll: (q) => {
                        return (allUsers || [])
                            .filter((u) => `${u.firstName} ${u.lastName}`
                            .toLowerCase()
                            .indexOf(q.toLowerCase()) !== -1 || q.length === 0)
                            .map((u) => ({
                            key: u.id,
                            heading: `${u.firstName} ${u.lastName}`,
                            subheading: u.role,
                            returnData: u,
                        }));
                    }, onSelect: (result) => {
                        setResponsibleUdbetalingsrekvisition(result.id);
                        localStorage.setItem('economyResponsibleUserId', result.id ?? '');
                    }, static: (() => {
                        const user = (allUsers || []).find((u) => u.id === responsibleUdbetalingsrekvisition);
                        return ((user && `${user.firstName} ${user.lastName}`) ||
                            responsibleUdbetalingsrekvisition);
                    })(), onRemoveStatic: () => {
                        setResponsibleUdbetalingsrekvisition(null);
                        localStorage.setItem('economyResponsibleUserId', '');
                    }, searchDelay: 0, forceOpen: true, placeholder: lang.tribunal.responsible }),
                React.createElement("p", null,
                    lang.financials.principal,
                    ": ",
                    React.createElement("b", null, formatNumber(getTotalAmount()))),
                React.createElement(MoneyInput, { placeholder: lang.tribunal.requisition, value: getUdbetalingsrekvisitionAmount(), onChange: (_amount) => {
                        setCourtFee(_amount);
                    }, allowNull: true }),
                React.createElement(Button, { block: true, disabled: !(udbetalingsrekvisitionType != null &&
                        getUdbetalingsrekvisitionAmount() &&
                        responsibleUdbetalingsrekvisition &&
                        getTotalAmount() &&
                        court), loading: loadingUdbetalingsrekvisition, onClick: sendRequisition }, lang.tribunal.sendRequisition)))));
};
export default UdbetalingsrekvisitionModal;
//# sourceMappingURL=UdbetalingsrekvisitionModal.js.map